import DomPurify from 'dompurify';

window.DomPurify = DomPurify;

export default { DomPurify };
